<template>
	<button class="bg-red-700 oomph uppercase text-xl text-white py-2 px-4 hover:bg-red-900 rounded pointer border-4 border-black shadow-xl">
		{{ text }}
	</button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'Button',

	props: {
		text: { type: String, default: '' }
	}
})
</script>